module.exports = __webpack_public_path__ + "static/unnayanaa-36e0666c9c3b43569ea2c85bb6e89153.jpg";